import { createSelector } from 'reselect';
import dayjs from '../../../../utils/dayjs';

export const allPlansSelector = state => state.planReducer.allPlans;

export const loadingPlansSelector = state => state.planReducer.loadingPlans;

export const loadingPlanSubscriptionsSelector = state => state.planReducer.loadingPlanSubscriptions;

export const plansSelector = state => state.planReducer.plans;

export const planSelector = state => state.planReducer.currentPlan;

export const currenciesSelector = state => state.planReducer.currencies;

export const currencySelector = state => state.planReducer.currentPlan.currency;

export const planSubscriptionsSelector = state => state.planReducer.planSubscriptions;

export const planIdSelector = createSelector(planSelector, plan => (plan ? plan.planId : null));

export const planNameSelector = createSelector(planSelector, plan => (plan ? plan.name : null));

export const branchIdSelector = createSelector(planSelector, plan => (plan ? plan.branchId : null));

export const planDateSelector = createSelector(planSelector, plan => (plan ? plan.lastModifiedDate : null));

function expiryMoment(subscription) {
  const raw = subscription?.expiryDate ?? subscription?.ExpiryDate;
  if (!raw) return null;
  const parsed = dayjs(raw);
  if (!parsed.isValid() || parsed.year() <= 1) return null;
  return parsed;
}

/** Subscriptions on the plan from GET /plans. That payload owns expiryDate. */
export function planSubscriptions(plan) {
  return Array.isArray(plan?.subscriptions) ? plan.subscriptions : [];
}

export function isPromoBackedSubscription(subscription) {
  const code = subscription?.promoCodeCode ?? subscription?.promoCode;
  const text = String(code ?? '').trim();
  return text !== '' && text !== '-' && text.toLowerCase() !== 'null';
}

export function isPromoBackedPlan(plan) {
  return planSubscriptions(plan).some(isPromoBackedSubscription);
}

export function isSubscriptionAccessRevoked(subscription) {
  if (!subscription) return false;
  if (subscription.isRevoked === true) return true;
  const status = String(subscription.status ?? '').trim().toLowerCase();
  return status === 'revoked';
}

/** Yes when any subscription on the plan has access revoked. */
export function isPlanAccessRevoked(plan) {
  return planSubscriptions(plan).some(isSubscriptionAccessRevoked);
}

/** Earliest subscription expiryDate, formatted DD/MM/YYYY. Does not invent a date from activeDate. */
export const getExpiryDate = (plan) => {
  const moments = planSubscriptions(plan).map(expiryMoment).filter(Boolean);
  if (!moments.length) return null;
  const earliest = moments.reduce((current, next) => (next.isBefore(current) ? next : current));
  return earliest.format('DD/MM/YYYY');
};

export function isExpiryBeforeToday(expiry) {
  if (!expiry) return false;
  const parsed = dayjs(expiry, 'DD/MM/YYYY');
  if (!parsed.isValid()) return false;
  return parsed.startOf('day').isBefore(dayjs().startOf('day'));
}

export const planExpiryDateSelector = createSelector(planSelector, (plan) => getExpiryDate(plan));

export const mtpdSelector = createSelector(planSelector, plan => (plan ? plan.mtpd : undefined));

export const mtpdDaysSelector = createSelector(mtpdSelector, mtpd => (mtpd ? mtpd.value : null));
